var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 716,
    viewBox: "0 0 800 716",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.111 0.445312V578.222H488.887V0.445312H311.111ZM440 49.3341H360V529.334H440V49.3341ZM44.4443 178.223H222.222V578.222H44.4443V178.223ZM93.3331 227.112H173.333V529.334H93.3331V227.112Z",
    fill: "rgba(46, 141, 251)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M800 667.113H0V716.001H800V667.113Z",
    fill: "rgba(46, 141, 251)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.779 267.113H755.554V578.223H577.779V267.113ZM626.667 316.002H706.667V529.335H626.667V316.002Z",
    fill: "rgba(46, 141, 251)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics1);
export default __webpack_public_path__ + "static/media/Analytics1.0afc5340e3961a2e5969cd0f7c83295e.svg";
export { ForwardRef as ReactComponent };